
import {defineComponent,ref} from "vue";
import cuadrosVisor from '@/pages/difusion/cuadrosVisor.vue'

export default defineComponent({

    components: {
        'cuadrosVisor': cuadrosVisor
    }, 

    setup() {
        const error$ = ref({mostrar: false, msg: ''}) 
        const id_cuadro = 34;

        return { error$, id_cuadro};
    },
    methods: {
        home(){
            this.$router.push({path: '/'});
        }
    },
    mounted() {
        // Desactivar un <link> específico al cargar el componente
        const link1 = document.getElementById("gobmx1");
        const link2 = document.getElementById("gobmx2");
        const link3 = document.getElementById("gobmx3");
        const div01 = document.getElementById("accessibility");
        const header = document.querySelector('header');
        const footer = document.querySelector('footer');

        if (link1) { link1.setAttribute('disabled', 'true') }
        if (link2) { link2.setAttribute('disabled', 'true') }
        if (link3) { link3.setAttribute('disabled', 'true') }
        if (div01) { div01.style.display = 'none' }
        if (header) { header.style.display = 'none' }
        if (footer) { footer.style.display = 'none' }
    },
    beforeUnmount() {
        // Reactivar un <link> específico al descargar el componente
        const link1 = document.getElementById("gobmx1");
        const link2 = document.getElementById("gobmx2");
        const link3 = document.getElementById("gobmx3");
        const div01 = document.getElementById("accessibility");
        const header = document.querySelector('header');
        const footer = document.querySelector('footer');

        if (link1) { link1.removeAttribute('disabled') }
        if (link2) { link2.removeAttribute('disabled') }
        if (link3) { link3.removeAttribute('disabled') }
        if (div01) { div01.style.display = 'block' }
        if (header) { header.style.display = 'block' }
        if (footer){ footer.style.display = 'block' }
    }
});
